import { OrderFulfillmentReducedFragment } from '../../../../../graphql/fragments/orderFulfillmentReduced.generated';
import { OrderFulfillment } from '../../../../../graphql/generatedTypes';

const getAllContainerTypesFromOrderfulfillments = (
  orderFulfillments: OrderFulfillmentReducedFragment[] | OrderFulfillment[],
): number[] => {
  const containerTypeSet = new Set<number>();

  for (const off of orderFulfillments) {
    const containerStations = off.container_stations;
    const singleContainers = off.single_containers;
    const goodwill = off.goodwill;
    const manualAmountsOf = off.manual_amounts;

    containerStations.forEach((cs) => {
      const containers = cs.containers;
      const manualAmounts = cs.manual_amounts;

      containers.forEach((c) => {
        containerTypeSet.add(c.container_type_id);
      });

      manualAmounts.forEach((m) => {
        containerTypeSet.add(m.container_type_id);
      });
    });

    [...singleContainers, ...goodwill, ...manualAmountsOf].forEach((c) => {
      containerTypeSet.add(c.container_type_id);
    });
  }

  return Array.from(containerTypeSet);
};

export default getAllContainerTypesFromOrderfulfillments;
